<app-modal-shell
  [isOpen]="isOpen"
  title="Publicando notas"
  [panelClass]="'max-w-[24rem] w-[92vw] px-0 sm:px-0'"
  [bodyClass]="'p-0'"
  [closeOnBackdropClick]="false"
  (fechado)="onClose()">
  
  <div class="flex flex-col max-h-[75vh]">
    <div class="overflow-y-auto px-5 py-2">
      <div *ngFor="let item of itens" class="flex items-center justify-between py-3.5 border-b border-gray-200 dark:border-gray-700 last:border-0">
        <span class="text-[15px] font-medium text-gray-700 dark:text-gray-200">{{ item.descricao }}</span>
        
        <button type="button" 
                (click)="onToggle(item)"
                class="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border transition-colors outline-none focus:ring-0 active:scale-95"
                [ngClass]="(item.nota.avaliavel.publicavel?.publicado ?? item.nota.avaliavel.publicado)
                  ? 'border-emerald-400 bg-emerald-100 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
                  : 'border-gray-200 bg-white text-gray-500 hover:border-emerald-300 hover:text-emerald-600 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300'"
                [title]="(item.nota.avaliavel.publicavel?.publicado ?? item.nota.avaliavel.publicado) ? 'Despublicar' : 'Publicar'">
          
          <lucide-icon *ngIf="item.loading" name="loader-2" class="h-5 w-5 animate-spin"></lucide-icon>
          <lucide-icon *ngIf="!item.loading" name="earth" class="h-5 w-5"></lucide-icon>

          <span *ngIf="(item.nota.avaliavel.publicavel?.publicado ?? item.nota.avaliavel.publicado) && !item.loading"
                class="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-emerald-500 text-white shadow">
            <lucide-icon name="check" class="h-3 w-3"></lucide-icon>
          </span>
        </button>
      </div>
    </div>
    
    <div class="px-5 py-4 w-full bg-white dark:bg-gray-800 rounded-b-md border-t border-gray-100 dark:border-gray-700/50">
      <button type="button" (click)="onClose()" class="w-full block px-4 py-2.5 text-[13px] font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700 transition-colors uppercase tracking-wide text-center">
        Fechar
      </button>
    </div>
  </div>
</app-modal-shell>
